import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { DocumentoProcessoService } from '../../../services/documento-processo.service';
import { BaseResponse } from '../../../../../core/models/base-response';

@Component({
  selector: 'app-nova-pasta-documento',
  templateUrl: './nova-pasta-documento.component.html',
  styleUrls: ['./nova-pasta-documento.component.css'],
  standalone: false
})
export class NovaPastaDocumentoComponent {
  @Input() origemId: number = 0;
  @Output() pastaCriada = new EventEmitter<boolean>();

  modalAberta = false;
  loading = false;
  formPasta: FormGroup;

  constructor(
    private fb: FormBuilder,
    private documentoService: DocumentoProcessoService,
    private toastr: ToastrService
  ) {
    this.formPasta = this.fb.group({
      descricao: ['', Validators.required]
    });
  }

  abrir() {
    this.modalAberta = true;
    this.formPasta.reset();
  }

  fechar() {
    this.modalAberta = false;
  }

  salvar() {
    if (this.formPasta.invalid) {
      this.toastr.error('Por favor, preencha a descrição da pasta.');
      return;
    }

    this.loading = true;
    const request = {
      descricao: this.formPasta.value.descricao,
      origemId: this.origemId
    };

    this.documentoService.novaPasta(request).subscribe({
      next: (res: BaseResponse<boolean>) => {
        this.loading = false;
        if ((res as any).sucesso) {
          this.toastr.success('Pasta criada com sucesso!');
          this.pastaCriada.emit(true);
          this.fechar();
        } else {
          this.toastr.error((res as any).errors?.[0]?.mensagem || 'Erro ao criar pasta.');
        }
      },
      error: (_: any) => {
        this.loading = false;
        this.toastr.error('Erro ao conectar ao servidor.');
      }
    });
  }
}
